export default __webpack_public_path__ + "static/media/rgp_pvh_nca_almati_region.eeb1d350.png";